import { Card, Flex, Skeleton, Typography } from "antd";
import styled from "styled-components";

export const BusinessCardContainer = styled(Card)(({ theme }) => ({
  width: "100%",
  minWidth: 240,
  maxWidth: 320,
  borderRadius: theme.borderRadius * 1.5,
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
  overflow: "hidden",
  height: "min-content",

  "& .ant-card-body": {
    padding: "12px",
    paddingBlock: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  "& .ant-card-cover": {
    display: "flex",
    position: "relative",
    height: 180,
    overflow: "hidden",
    borderRadius: theme.borderRadius,
    margin: theme.spacing * 0.5,
    marginBottom: 0,

    "& .ant-skeleton-element": {
      flexGrow: 1,
    },

    "& >*": {
      display: "flex",
    },
  },

  "& .ant-card-cover img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

export const BusinessCardContentContainer = styled(Flex)({
  flex: 1,
  gap: 12,
  width: "100%",
  maxWidth: "100%",
});

export const BusinessCardTextContainer = styled(Flex)({
  minWidth: 0,
  flex: 1,
});

export const BusinessCardTagsContainer = styled(Flex)({
  display: "flex",
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  padding: 8,
  rowGap: 6,
});

export const BusinessTitle = styled("h5")({
  fontSize: 14,
  marginBottom: 0,
  fontWeight: 500,
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const BusinessAddress = styled(Typography.Text)({
  fontSize: 12,
});

export const BusinessCardImageSkeleton = styled(Skeleton.Node)({
  "&.ant-skeleton.ant-skeleton-active .ant-skeleton-image": { width: "100%", height: "100%" },
});
